import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont-weapp-icon.css'
import utils from './assets/js/utils.js'; // 公共的函数方法
import Print from 'vue-print-nb';
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
import common from './common/common.js';

import {
	myRequest
} from './common/api.js'
import {
	Interface
} from './common/Interface.js'

import validation from './assets/js/validation.js'; //自定义处理数字
import authority from './assets/js/authority.js'; //自定义处按钮权限控制

import './plugins/quick.js'

Vue.use(ElementUI);
Vue.use(Print);
Vue.use(VueTinymce);
Vue.config.productionTip = false

Vue.prototype.$Request = myRequest;
Vue.prototype.$Interface = Interface;
Vue.prototype.$Common = common;
Vue.prototype.$utils = utils;
Vue.prototype.$tinymce = tinymce

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')